import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import MergerSubsDetailList from "containers/mergersubs/MergerSubsDetailList";
import Moment from "moment";
import React, { Component } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import ReactTable from "react-table";
import 'react-table/react-table.css';




const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class MergerSubList extends Component {
    constructor(props) {
        super(props);

        this.updateTableState = this.updateTableState.bind(this);
        this.saveRecord = this.saveRecord.bind(this);        
        this.validateRelatedRecord = this.validateRelatedRecord.bind(this);

        this.state = {
            searching: false,
            isLoading: true,
            mergerSubs: [],
            mergerSubDetails: [],
            filter: {},
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false,
            showDetailDialog: false,
            selectedCityscope: null,
            cityscopeOptions: [],
            cityscope: null,
            appendix: null,
            index: null,
            mergersubid: null,
            selected: null ,
            typeOptions: [{value: "S", label: "Sub Division"},{value: "M", label: "Merger"},{value: 'N', label: 'New Property'},{value: 'R', label:'Removed Property'}],
            sourceDestinationOptions: [{value: "S", label: "Source"},{value: "D", label: "Destination"}]

        };

        
    }
    

    async componentDidMount() {
        console.log("In MergerSubList componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }
        await this.getCityscopes();

        const mergerSubs = await this.getMergerSubs({cityscope: this.state.cityscope
            });
        this.setState({ mergerSubs });
        
        

        document.title = "Mergers & Sub Divisions";
        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ mergerSubs: [] });        
    }

    async getMergerSubs(filter) {
        console.log("Inside getMergerSubs() ");
        
        return API.get("colin", "/mergersubs", { 'queryStringParameters': filter });
      
    }

    
    async getCityscopes() {
        try {
            API.get("colin", `/cityscopes/dropdown`, { 'cancelToken': source.token }).then((cityscopeOptions) => {
                if (cityscopeOptions) {
                    this.setState(state => ({ cityscopeOptions }));
                }
            });
        }
        catch{
            console.log("Error getting cityscopes");
        }
    }    



    

    handleSubmit = async event =>{
        event.preventDefault();
        this.setState({mergerSubDetails: []});
        try {
            const mergerSubs = await this.getMergerSubs({cityscope: this.state.cityscope
                                                    });
            mergerSubs.sort((a, b) => {
                return (
                    (a.created_date === null) - (b.created_date === null)
                    || -(a.created_date > b.created_date) || +(a.created_date < b.created_date)
                );
            });
            this.setState({ mergerSubs });
        } catch (e) {
            alert(e);
        }
    }
    
    handleInputChange = (cellInfo, event) => {
        
        let mergerSubs = [...this.state.mergerSubs];
        mergerSubs[cellInfo.index][cellInfo.column.id] = event.target.value;
        mergerSubs[cellInfo.index].modified = true;
        this.setState({mergerSubs});
    };
    handleNumberChange = (cellInfo, event) => {
        
        let mergerSubs = [...this.state.mergerSubs];
        let val = event.target.value.replace(/[^0-9]/g, "");        
        mergerSubs[cellInfo.index][cellInfo.column.id] = val;
        mergerSubs[cellInfo.index].modified = true;
        this.setState({mergerSubs});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let mergerSubs = [...this.state.mergerSubs];
        mergerSubs[cellInfo.index][cellInfo.column.id] = event.target.checked;
        mergerSubs[cellInfo.index].modified = true;
        this.setState({mergerSubs});
       
    };

    handleDateChange = (cellInfo, event) => {
        let mergerSubs = [...this.state.mergerSubs];
        mergerSubs[cellInfo.index][cellInfo.column.id] = new Date(event);
        mergerSubs[cellInfo.index].modified = true;
        this.setState({mergerSubs});

    }

    handleDropDownChange = (cellInfo, event) => {

        let mergerSubs = [...this.state.mergerSubs];
        mergerSubs[cellInfo.index][cellInfo.column.id] = event.value;
        mergerSubs[cellInfo.index].modified = true;
        this.setState({mergerSubs});


        
    }


    handleCityscopeChange = async  (selectedCityscope) => {
        
        this.setState({selectedCityscope: selectedCityscope,cityscope: selectedCityscope.value, appendix: selectedCityscope.appendix});
    }


    validateRelatedRecord(record, set) {
        console.log(record);
        if (set === "mergerSubs") {

           
            if (!record.appendix) {
                return [false, "You must enter an appendix."];
            }

            if (!record.type) {
                return [false, "You must select a type of change."];
            }

        }

        if (set === "mergerSubDetails") {


            if (!record.property_key) {
                return [false, "Enter a cityscope reference."];
            }

            


        }

        return [true,];
    }

    async handleDataSave(record,id) {
        console.log("In handleDataSave");
        record.last_edited_by = this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                return API.post("colin", `/mergersubs/new`, {
                    body: record
                });
            }
        }
        //If not a new record and updating an existing, perform a put
        return API.put("colin", `/mergersubs/${record.merger_sub_id}`, {
            body: record
        }
        );
    }

    handleSave = async (event) => {

        this.setState({ showAlert: false });
        

        let data = [...this.state.mergerSubs];
        for (var i=0; i<data.length; i++){
            
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        const validation = this.validateRelatedRecord(data[i], "mergerSubs");
                        console.log(validation[0]);
                        if (validation[0] === true) {
                            console.log(validation[0])
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i].merger_sub_id = result.id;
                                        this.setState({ savingNewRecord: false });  
                                        this.setState({index: 0, mergersubid: result.id});                                      

                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }
                    else {
                        this.setState({ errorMessage: validation[1] });
                        this.setState({ showAlert: true });
                    }
                    }
                    

                }
            
        }   
        if (data[0].hasOwnProperty("sort_order")) {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        this.setState({mergerSubs: data});


    }

    addRecord = async event => {
        let mergerSubs = [...this.state.mergerSubs];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        mergerSubs.unshift({
            merger_sub_id: null,
            cityscope: this.state.cityscope,
            appendix: this.state.appendix,
            type: "M",
            description: "",
            updated: false,
            mergersubs_list: [],
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.setState({mergerSubs});
    }

    
    renderEditable = cellInfo => {
        const cellValue = this.state.mergerSubs[cellInfo.index][cellInfo.column.id];
        
        
        if (cellInfo.column.id  === "cityscope") {
            if (cellValue) {
                return (<div><Select
                    value={{ value: cellValue, label: cellValue }}
                    onChange={this.handleDropDownChange.bind(null, cellInfo)}
                    options={this.state.cityscopeOptions}
                    onBlur={this.handleSave.bind(null)}
                    className="no-border"
                /></div>
                );
            }
            else {
                return (<div><Select
                    value={{value: null, label: null}}
                    onChange={this.handleDropDownChange.bind(null, cellInfo)}
                    options={this.state.cityscopeOptions}
                    onBlur={this.handleSave.bind(null)}
                    className="no-border"
                /></div>
                );
            }
        }
         
        if (cellInfo.column.id  === "type") {
            if (cellValue) {
                return (<div><Select
                    value={{ value: cellValue, label: this.state.typeOptions.find(o => o.value === cellValue).label }}
                    onChange={this.handleDropDownChange.bind(null, cellInfo)}
                    options={this.state.typeOptions}
                    onBlur={this.handleSave.bind(null)}
                    className="no-border"
                /></div>
                );
            }
            else {
                return (<div><Select
                    value={{value: null, label: null}}
                    onChange={this.handleDropDownChange.bind(null, cellInfo)}
                    options={this.state.typeOptions}
                    onBlur={this.handleSave.bind(null)}
                    className="no-border"
                /></div>
                );
            }
        }
         

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null)}
                        
                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null)}
                                    
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }

    

    
    handleSelectRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("select record");
        let mergerSubs = [...this.state.mergerSubs];
        let mergerSub = mergerSubs[cellInfo.index];
        const mergerSubDetails = (mergerSub.mergersubs_list|| []);
        this.setState({index: cellInfo.index, mergersubid: mergerSub.merger_sub_id});
        this.setState({mergerSubDetails});
            
            
 
    };
    
    updateTableState(data) {
        
        this.setState({mergerSubDetails: data });

        let mergerSubs = [...this.state.mergerSubs];
        mergerSubs[this.state.index].mergersubs_list = data;
        this.setState({mergerSubs });
     
    }


     
    addRecord(){
        
        let mergerSubs = [...this.state.mergerSubs];
        
        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        mergerSubs.unshift({
            merger_sub_id: null,
            cityscope: this.state.cityscope,
            type: null,
            appendix: this.state.cityscopeOptions.find(o => o.value === this.state.cityscope).appendix,
            description: "",
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.setState({mergerSubs});

          

    }

    handleUpdateArticleLinks = async (cellInfo, event) => {
        event.preventDefault();
        API.post("colin", `/mergersubs/${cellInfo.original.merger_sub_id}/updatelinks`, {
            body: cellInfo.original
        }).then((result) => {
            console.log(result);
            if (result) {
                let mergerSubs = [...this.state.mergerSubs];
                mergerSubs[cellInfo.index].updated = true;
                mergerSubs[cellInfo.index].modified = true;
                this.setState(mergerSubs);
                this.handleDataSave(mergerSubs[cellInfo.index], mergerSubs[cellInfo.index].merger_sub_id);
            };

        });
        
    }


    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete merger sub division");
        let mergerSubs = [...this.state.mergerSubs];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            mergerSubs[cellInfo.index].archived_date = new Date();
            mergerSubs[cellInfo.index].modified = true;
            this.setState(mergerSubs);
            await this.handleDataSave(mergerSubs[cellInfo.index], mergerSubs[cellInfo.index].merger_sub_id).then((result) => {
                console.log("In save callback")
                mergerSubs.splice(cellInfo.index, 1);
                this.setState({mergerSubs});
            }
            )
        };
    };

    saveRecord(record, endpoint, id) {
        console.log("Inside save record");
        record.last_edited_by = this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                return API.post("colin", `/mergersubs/${record.merger_sub_id}/${endpoint.toLowerCase()}/new`, {
                    body: record
                });
            }
        }
        //If not a new record and updating an existing, perform a put
        return API.put("colin", `/mergersubs/${record.merger_sub_id}/${endpoint.toLowerCase()}/${record[id]}`, {
            body: record
        }
        );
    }

    renderButton = cellInfo => {
        if (!cellInfo.original.updated){
            return( <Button type="button" size="sm" variant="primary" onClick={(e) => this.handleUpdateArticleLinks(cellInfo,e)}>Update Article Links</Button>);
        }
        else{
            return(null);
        }
    }
    renderTable(data) {
        const columns = [

            {
                id: 'merger_sub_id',
                Header: 'ID',
                maxWidth: 80,
                accessor: 'merger_sub_id' ,
                Cell: row => <Button type="button" size="sm" variant="link" onClick={(e) => this.handleSelectRecord(row,e)}>{row.value}</Button>
        }
        , {
                id: 'cityscope',
                Header: 'Cityscope',            
                accessor: 'cityscope',
                Cell: this.renderEditable,
                maxWidth: 100
                

            }, {
                id: 'appendix',
                Header: 'Appendix',            
                accessor: 'appendix',
                Cell: this.renderEditable,
                maxWidth: 150

            }
            ,
            {
                id: 'type',
                Header: 'Type',            
                accessor: 'type',
                Cell: this.renderEditable,
                maxWidth: 150

            }
            ,
            {
                id: 'description',
                Header: 'Description',            
                accessor: 'description',
                Cell: this.renderEditable,
                maxWidth: 400

            } ,
            {
                id: 'updated',
                Header: 'Links Updated',            
                accessor: 'updated',
                Cell: this.renderEditable,
                maxWidth: 100,
                style: { textAlign: "center" }

            } ,
            {
                id: 'created_date',
                Header: 'Created Date',
                maxWidth: 100,
                style: { textAlign: "center" },
                accessor: d => {
                    if (d.created_date) {
                        return Moment(d.created_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                }
            },{
                Header: '',
                accessor: 'merger_sub_id',
                maxWidth: 165,
                Cell: this.renderButton
            },{
                Header: '',
                accessor: 'merger_sub_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
            }
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <Row><Col lg={8}>
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={20}
                    sortable={false}      
                    getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                          return {
                            onClick: (e) => {
                              this.setState({
                                selected: rowInfo.index
                              })
                              this.handleSelectRecord(rowInfo,e)
                            },
                            style: {
                              background: rowInfo.index === this.state.selected && rowInfo.original.merger_sub_id != null ? '#00afec' : 'white',
                              color: rowInfo.index === this.state.selected && rowInfo.original.merger_sub_id != null ? 'white' : 'black'
                            }
                          }
                        }else{
                          return {}
                        }
                      }
                    }                                              
                />
                </Col>
                <Col>
                    <MergerSubsDetailList                            
                        isAuthenticated={this.props.isAuthenticated}
                        isLoading={this.state.isLoading}
                        controlType="table"
                        saveForm={this.state.saveForm}
                        user={this.props.user}
                        data={this.state.mergerSubDetails}
                        updateTableState={this.updateTableState}
                        saveRecord={this.saveRecord}
                        deleteRecord={this.deleteRecord}
                        validateRelatedRecord={this.validateRelatedRecord}
                        mergersubid={this.state.mergersubid}
                        index={this.state.index}
                        toggleDetailDialog={this.toggleDetailDialog}
                    />
                </Col>
                </Row>
            )
        }
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
        this.setState({ modified: true });
    }

   


    renderComponent() {
        return (
            <div className="mergersubs">
                
                            
                                
                        
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                <form onSubmit={this.handleSubmit}>
                 <Row >
                     <Col  sm={2} md={2} lg={2}>
                     <Form.Group as={Row}  controlId="cityscope" >
                     
                        <Col>
                        <Select
                            value={this.state.selectedCityscope}
                            onChange={this.handleCityscopeChange}
                            options={this.state.cityscopeOptions}
                            // onInputChange={this.handleChange}
                            placeholder="Cityscope"
                            
                        />
                        </Col>


                    </Form.Group>
                     </Col>
                 
                        <Col sm={2} md={2} lg={2}>
                        <Button type="submit" variant="primary">Search</Button>
                        </Col>

                        <Col className="text-right" sm={2} md={2} lg={4}>
                        
                            <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>

                        </Col>
                        <Col className="text-right" sm={2} md={2} lg={4}>
                        
                            

                        </Col>

                    </Row> 
                    </form>
                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.mergerSubs) : this.renderTable(this.state.mergerSubs)  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="AgentList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
